module.exports = __webpack_public_path__ + "static/media/pomo2.e89df8ae.png";